import React from 'react';

import { DataTable, type TableColumn } from '@/src/ui';
import { ReportHeaderStyle, ReportCellStyle } from '@/src/utils';
import type { StudentMasteryByDomainDTO } from '../models/studentStandardsReportDTOs';

interface StudentMasteryByDomainProps {
    data: StudentMasteryByDomainDTO[];
    pdfFileName?: string | (() => string);
}

const StudentDomainMasteryTable: React.FC<StudentMasteryByDomainProps> = ({
    data,
    pdfFileName,
}) => {
    const columns: TableColumn[] = [
        {
            dataKey: 'domainName',
            header: 'Domain',
            align: 'left',
            allowSort: true,
            emptyValue: '-',
            headerSx: ReportHeaderStyle,
            cellSx: ReportCellStyle,
            formatter: (r: any) =>
                r.domainName && r.domainShortName
                    ? `${r.domainName} (${r.domainShortName})`
                    : r.domainName || r.domainShortName || '-',
        },
        {
            dataKey: 'questionsCorrect',
            header: 'Correct',
            align: 'left',
            allowSort: true,
            emptyValue: '-',
            headerSx: ReportHeaderStyle,
            cellSx: ReportCellStyle,
            formatter: (r: any) => `${r.questionsCorrect ?? 0}`,
        },
        {
            dataKey: 'questionsTotal',
            header: 'Total',
            align: 'left',
            allowSort: true,
            emptyValue: '-',
            headerSx: ReportHeaderStyle,
            cellSx: ReportCellStyle,
            formatter: (r: any) => `${r.questionsTotal ?? 0}`,
        },
        {
            dataKey: 'percentCorrect',
            header: 'Student %',
            align: 'left',
            allowSort: true,
            emptyValue: '-',
            headerSx: ReportHeaderStyle,
            cellSx: ReportCellStyle,
            formatter: (r: any) => `${r.percentCorrect ?? 0}%`,
        },
    ];

    return (
        <div className="w-full overflow-auto">
            <br />

            <div className="pl-4">
                <h2
                    className="inline-block text-lg px-2 py-2 pl-4 bg-[var(--pm-secondary-light)] text-[var(--pm-dark)] rounded-t-lg tracking-wide whitespace-nowrap"
                    style={{
                        fontFamily: 'Verdana, Geneva, sans-serif',
                        boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.4)',
                    }}
                >
                    Domain Mastery
                </h2>
            </div>

            <DataTable
                data={data}
                columns={columns}
                tableName="StudentDomainMasteryTable"
                emptyMessage="No domain mastery found."
                rowsPerPageInitial={20}
                enableExportCSV
                enableExportExcel
                enableExportPDF
                pdfFileName={pdfFileName}
                alternatingRowColor
                defaultSortColumn="domainName"
                defaultSortDirection="asc"
            />
        </div>
    );
};

export default StudentDomainMasteryTable;
